<mat-card class="users-card" appearance="outlined">
  <ng-template #noRead>
    <app-authorized-guard
      [authorized]="false"
      message="You are not authorized to view this data"
    ></app-authorized-guard>
  </ng-template>
  <mat-card-content *hasPrivilege="'tenant_user/read'; else noRead">
    <div>
      <app-loading-guard [loading]="entityList.loading">
        <app-authorized-guard [authorized]="!unauthorized">
          <mat-table
            id="organization-users-table"
            class="kahi-table"
            [dataSource]="entityList.entities"
          >
            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
              <mat-cell *matCellDef="let user">
                <a (click)="viewUser(user)" class="user-email">
                  {{ user.email }}
                </a>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
              <mat-cell *matCellDef="let user">
                {{ user.name }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
              <mat-cell *matCellDef="let user">
                {{ getUserFriendlyType(user) }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="last_sign_in">
              <mat-header-cell *matHeaderCellDef>Last Sign In</mat-header-cell>
              <mat-cell *matCellDef="let user">
                {{ user.last_sign_in_at | formatDate : time_zone }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="actions">
                  <button
                    mat-raised-button
                    rippleOnHover
                    color="primary"
                    [routerLink]="['/users', item.id, 'edit']"
                    class="edit-button"
                    *hasPrivilege="'tenant_user/update'"
                  >
                    Edit
                  </button>
                  <button
                    mat-icon-button
                    rippleOnHover
                    color="primary"
                    (click)="deleteUser(item)"
                    *hasPrivilege="'tenant_user/destroy'"
                  >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedUserColumns"
            ></mat-header-row>
            <mat-row
              class="row"
              *matRowDef="let row; columns: displayedUserColumns"
            ></mat-row>
          </mat-table>

          <mat-paginator
            [length]="entityList.total"
            [pageIndex]="entityList.page - 1"
            [pageSize]="entityList.perPage"
            [pageSizeOptions]="[20, 50, 100]"
            (page)="onPageEvent($event)"
          ></mat-paginator>
        </app-authorized-guard>
      </app-loading-guard>
    </div>
  </mat-card-content>
</mat-card>

<app-portal name="organization-actions">
  <button
    mat-raised-button
    color="accent"
    class="new-user"
    *hasPrivilege="'tenant_user/create'"
    [routerLink]="['/users', 'create']"
  >
    New User
  </button>
</app-portal>
